import React from "react"

export const FacebookIcon = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="white"
        d="M15.997 3.985h2.191V.169C17.81.117 16.51 0 14.996 0c-3.159 0-5.323 1.987-5.323 5.639V9H6.187v4.266h3.486V24h4.274V13.267h3.345l.531-4.266h-3.877V6.062c.001-1.233.333-2.077 2.051-2.077z"
      ></path>
    </svg>
  )
}

export const PinterestIcon = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 999.9 999.9"
      {...props}
    >
      <path
        fill="white"
        d="M0 500c2.6-141.9 52.7-260.4 150.4-355.4S364.6 1.3 500 0c145.8 2.6 265.3 52.4 358.4 149.4 93.1 97 140.3 213.9 141.6 350.6-2.6 140.6-52.7 258.8-150.4 354.5-97.7 95.6-214.2 144.1-349.6 145.4-46.9 0-93.7-7.2-140.6-21.5 9.1-14.3 18.2-30.6 27.3-48.8 10.4-22.1 23.4-63.8 39.1-125 3.9-16.9 9.8-39.7 17.6-68.4 9.1 15.6 24.7 29.9 46.9 43 58.6 27.3 120.4 24.7 185.5-7.8 67.7-39.1 114.6-99.6 140.6-181.6 23.4-85.9 20.5-165.7-8.8-239.2C778.3 277 725.9 224 650.4 191.4c-95-27.3-187.5-24.4-277.3 8.8s-152.3 90.2-187.5 170.9C176.5 401 171 430.7 169 460c-2 29.3-1 57.9 2.9 85.9s13.7 53.1 29.3 75.2 36.5 39.1 62.5 50.8c6.5 2.6 11.7 2.6 15.6 0 5.2-2.6 10.4-13 15.6-31.2 5.2-18.2 7.2-30.6 5.9-37.1-1.3-2.6-3.9-7.2-7.8-13.7-27.3-44.3-36.5-90.8-27.3-139.6 9.1-48.8 29.3-90.2 60.5-124 48.2-43 104.5-66.4 168.9-70.3 64.4-3.9 119.5 13.7 165 52.7 24.7 28.6 40.7 63.1 47.8 103.5s7.2 79.1 0 116.2c-7.2 37.1-19.9 71.9-38.1 104.5-32.6 50.8-71 76.8-115.2 78.1-26-1.3-47.2-11.4-63.5-30.3s-21.2-40.7-14.6-65.4c2.6-14.3 10.4-42.3 23.4-84 13-41.7 20.2-72.9 21.5-93.7-3.9-49.5-26.7-74.9-68.4-76.2-32.6 3.9-56.6 18.6-72.3 43.9s-24.1 54.4-25.4 86.9c3.9 37.8 9.8 63.8 17.6 78.1-14.3 58.6-25.4 105.5-33.2 140.6-2.6 9.1-9.8 37.1-21.5 84s-18.2 82.7-19.5 107.4V957C206.3 914 133.3 851.9 80 770.5 26.7 689.1 0 598.9 0 500z"
      ></path>
    </svg>
  )
}

export const LinkedIn = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="white"
        d="M23.994 24v-.001H24v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07V7.976H8.489v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243V24zM.396 7.977h4.976V24H.396zM2.882 0C1.291 0 0 1.291 0 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909A2.884 2.884 0 002.882 0z"
      ></path>
    </svg>
  )
}
export const TwitterIcon = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="-0.25 -0.25 1109.5 901.5"
      {...props}
    >
      <path
        fill="white"
        stroke="#5da8dc"
        strokeWidth="0.5"
        d="M741 .2V0h52l19 3.8c12.667 2.467 24.167 5.7 34.5 9.7 10.334 4 20.334 8.667 30 14 9.667 5.333 18.434 10.767 26.301 16.3 7.8 5.467 14.8 11.267 21 17.4C929.933 67.4 939.5 69 952.5 66s27-7.167 42-12.5 29.834-11.333 44.5-18c14.667-6.667 23.601-10.9 26.801-12.7 3.133-1.866 4.8-2.866 5-3l.199-.3 1-.5 1-.5 1-.5 1-.5.2-.3.3-.2.301-.2.199-.3 1-.3 1-.2-.199 1.5-.301 1.5-.5 1.5-.5 1.5-.5 1-.5 1-.5 1.5c-.333 1-.666 2.333-1 4-.333 1.667-3.5 8.333-9.5 20S1051 73 1042 85s-17.066 21.066-24.199 27.2c-7.2 6.2-11.967 10.533-14.301 13-2.333 2.533-5.166 4.866-8.5 7l-5 3.3-1 .5-1 .5-.199.3-.301.2-.3.2-.2.3-1 .5-1 .5-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.3.2-.2.3h5l28-6c18.667-4 36.5-8.833 53.5-14.5l27-9 3-1 1.5-.5 1-.5 1-.5 1-.5 1-.5 2-.3 2-.2v2l-.5.2-.5.3-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.5 1-.5 1-.3.2c-.133.2-4.366 5.866-12.7 17-8.333 11.2-12.833 16.866-13.5 17-.666.2-1.6 1.2-2.8 3-1.133 1.866-8.2 9.3-21.2 22.3s-25.732 24.566-38.199 34.7c-12.533 10.2-18.867 22.733-19 37.6-.2 14.8-.967 31.534-2.301 50.2-1.333 18.667-3.833 38.833-7.5 60.5-3.666 21.667-9.333 46.167-17 73.5-7.666 27.333-17 54-28 80s-22.5 49.333-34.5 70-23 38.167-33 52.5-20.166 27.833-30.5 40.5c-10.333 12.667-23.399 26.934-39.199 42.8-15.867 15.8-24.533 24.467-26 26-1.533 1.467-8.066 6.934-19.601 16.4-11.466 9.533-23.8 19.066-37 28.6-13.133 9.467-25.2 17.367-36.2 23.7s-24.266 13.566-39.8 21.7C630.734 840.4 614 848 596 855s-37 13.5-57 19.5-39.333 10.667-58 14c-18.666 3.333-39.833 6.167-63.5 8.5l-35.5 3.5v.5h-65v-.5l-8.5-.5c-5.666-.333-10.333-.667-14-1-3.666-.333-17.5-2.167-41.5-5.5s-42.833-6.667-56.5-10c-13.666-3.333-34-9.667-61-19s-50.1-18.767-69.3-28.3c-19.133-9.467-31.133-15.467-36-18-4.8-2.467-10.2-5.533-16.2-9.2l-9-5.5-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3-.301-.2-.3-.2-.2-.3-.199-.3L.5 800H0v-2l1 .2 1 .3 4.5.5c3 .333 11.167.833 24.5 1.5 13.334.667 27.5.667 42.5 0s30.334-2.167 46-4.5c15.667-2.333 34.167-6.333 55.5-12 21.334-5.667 40.934-12.4 58.801-20.2 17.8-7.866 30.466-13.733 38-17.6 7.466-3.8 18.866-10.867 34.199-21.2l23-15.5.2-.3.3-.2.301-.2.199-.3.2-.3.3-.2.301-.2.199-.3 1-.3 1-.2.2-1 .3-1 .301-.2.199-.3-8-.5c-5.333-.333-10.5-.667-15.5-1s-12.833-1.833-23.5-4.5c-10.666-2.667-22.166-6.667-34.5-12-12.333-5.333-24.333-11.667-36-19-11.666-7.333-20.1-13.434-25.3-18.3-5.133-4.801-11.8-11.6-20-20.4-8.133-8.866-15.2-17.967-21.2-27.3s-11.733-20.101-17.199-32.3L124.5 551l-.5-1.5-.5-1.5-.3-1-.2-1 1.5.2 1.5.3 11 1.5c7.334 1 18.834 1.333 34.5 1 15.667-.333 26.5-1 32.5-2s9.667-1.667 11-2l2-.5 2.5-.5 2.5-.5.2-.3.3-.2.301-.2.199-.3-2-.5-2-.5-2-.5-2-.5-2-.5c-1.333-.333-3.666-1-7-2-3.333-1-12.333-4.667-27-11-14.666-6.333-26.333-12.5-35-18.5a241.7 241.7 0 01-24.8-19.7c-7.8-7.2-16.366-16.467-25.7-27.8-9.333-11.333-17.666-24.5-25-39.5-7.333-15-12.833-29.333-16.5-43a232.143 232.143 0 01-7.199-41.5L43 316l1 .2 1 .3 1 .5 1 .5 1 .5 1 .5 15.5 7c10.334 4.667 23.167 8.667 38.5 12 15.334 3.333 24.5 5.167 27.5 5.5l4.5.5h9l-.199-.3-.301-.2-.3-.2-.2-.3-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3c-.2-.134-3.067-2.267-8.601-6.4-5.467-4.2-11.2-9.633-17.2-16.3s-12-13.667-18-21A162.158 162.158 0 0177 271c-4.666-8.333-9.6-18.934-14.8-31.8-5.133-12.8-9.033-25.7-11.7-38.7-2.666-13-4.166-25.833-4.5-38.5-.333-12.667 0-23.5 1-32.5s3-19.167 6-30.5 7.334-23.333 13-36l8.5-19 .5-1.5.5-1.5.301-.2.199-.3.2-.3.3-.2.301.2.199.3.2.3.3.2.301.2.199.3.2.3.3.2.5 1 .5 1 .301.2.199.3 13.5 15c9 10 19.667 21.167 32 33.5 12.334 12.333 19.167 18.733 20.5 19.2 1.334.533 3 2.066 5 4.6 2 2.467 8.667 8.367 20 17.7 11.334 9.333 26.167 20.167 44.5 32.5 18.334 12.333 38.667 24.5 61 36.5 22.334 12 46.334 22.833 72 32.5 25.667 9.667 43.667 16 54 19 10.334 3 28 6.833 53 11.5s43.834 7.667 56.5 9c12.667 1.333 21.334 2.1 26 2.3l7 .2-.199-1.5-.301-1.5-2-12.5c-1.333-8.333-2-20-2-35s1.167-28.833 3.5-41.5c2.334-12.667 5.834-25.5 10.5-38.5 4.667-13 9.234-23.434 13.7-31.3 4.534-7.8 10.467-16.7 17.8-26.7 7.334-10 16.834-20.333 28.5-31 11.667-10.667 25-20.167 40-28.5s28.834-14.667 41.5-19c12.667-4.333 23.334-7.167 32-8.5 8.667-1.333 13-2.1 13-2.3z"
      ></path>
    </svg>
  )
}

export const InstagramIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 511 511.9"
    >
      <path
        fill="white"
        d="M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0074.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0"
      ></path>
      <path
        fill="white"
        d="M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zm0 0M423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0"
      ></path>
    </svg>
  )
}
export const YoutubeIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="-21 -117 682.667 682"
    >
      <path
        fill="white"
        d="M626.813 64.035c-7.375-27.418-28.993-49.031-56.407-56.414C520.324-6.082 319.992-6.082 319.992-6.082s-200.324 0-250.406 13.184c-26.887 7.375-49.031 29.52-56.406 56.933C0 114.113 0 217.97 0 217.97s0 104.379 13.18 153.933c7.382 27.414 28.992 49.028 56.41 56.41C120.195 442.02 320 442.02 320 442.02s200.324 0 250.406-13.184c27.418-7.379 49.032-28.992 56.414-56.406 13.176-50.082 13.176-153.934 13.176-153.934s.527-104.383-13.183-154.46zM256.21 313.915V122.022l166.586 95.946zm0 0"
      ></path>
    </svg>
  )
}

export function DownIcon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width={width}
      height={height}
      enableBackground="new 0 0 490.688 490.688"
      version="1.1"
      viewBox="0 0 490.688 490.688"
      xmlSpace="preserve"
    >
      <path
        fill="white"
        d="M472.328 120.529L245.213 347.665 18.098 120.529c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l234.667 234.667c4.165 4.164 10.917 4.164 15.083 0l234.667-234.667c4.237-4.093 4.354-10.845.262-15.083-4.093-4.237-10.845-4.354-15.083-.262-.089.086-.176.173-.262.262l-.021.001z"
      ></path>
      <path
        fill="white"
        d="M245.213 373.415a10.663 10.663 0 01-7.552-3.115L2.994 135.633c-4.093-4.237-3.975-10.99.262-15.083 4.134-3.992 10.687-3.992 14.82 0l227.136 227.115 227.115-227.136c4.093-4.237 10.845-4.354 15.083-.262 4.237 4.093 4.354 10.845.262 15.083-.086.089-.173.176-.262.262L252.744 370.279a10.672 10.672 0 01-7.531 3.136z"
      ></path>
    </svg>
  )
}

export function MobMenu({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 -53 384 384"
    >
      <path
        fill="white"
        d="M368 154.668H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 32H16C7.168 32 0 24.832 0 16S7.168 0 16 0h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 277.332H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0"
      ></path>
    </svg>
  )
}

export function CloseIcon({ width, height, color = "#fff", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      {...props}
    >
      <g fill={color}>
        <path d="M3.05 1.636L14.364 12.95a1 1 0 01-1.414 1.414L1.636 3.05A1 1 0 013.05 1.636z"></path>
        <path d="M14.364 3.05L3.05 14.364a1 1 0 01-1.414-1.414L12.95 1.636a1 1 0 011.414 1.414z"></path>
      </g>
    </svg>
  )
}

export const Quote = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    {...props}
  >
    <path
      fill="#4299e1"
      d="M49.182 32.9v9.8a2.1 2.1 0 01-2.1 2.1h-9.8a2.1 2.1 0 01-2.1-2.1V30.59c0-2.954 1.232-6.986 7.112-9.422a2.1 2.1 0 011.61 3.878c-4.046 1.68-4.522 3.962-4.522 5.544v.21h7.7c1.16 0 2.1.94 2.1 2.1zm-20.664-2.1h-7.7v-.21c0-1.582.476-3.864 4.522-5.544a2.1 2.1 0 00-1.61-3.878c-5.88 2.436-7.112 6.468-7.112 9.422V42.7c0 1.16.94 2.1 2.1 2.1h9.8a2.1 2.1 0 002.1-2.1v-9.8a2.1 2.1 0 00-2.1-2.1zM65.8 13.3v39.2c-.008 7.342-5.958 13.292-13.3 13.3H13.3C5.958 65.792.008 59.842 0 52.5V13.3C.008 5.958 5.958.008 13.3 0h39.2c7.342.008 13.292 5.958 13.3 13.3zm-4.2 0a9.111 9.111 0 00-9.1-9.1H13.3a9.111 9.111 0 00-9.1 9.1v39.2a9.111 9.111 0 009.1 9.1h39.2a9.111 9.111 0 009.1-9.1V13.3z"
    ></path>
  </svg>
)

export const Dropdown = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="31" height="31" fill="#14CCFF" rx="15.5"></rect>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M15.22 20.916a.509.509 0 00.56 0l6.98-4.559a.532.532 0 00.24-.448v-1.377a.53.53 0 00-.27-.466.505.505 0 00-.528.018l-6.423 4.38a.51.51 0 01-.558 0l-6.423-4.38a.506.506 0 00-.529-.018.532.532 0 00-.269.466v1.377c0 .182.09.35.24.448l6.98 4.56z"
      ></path>
    </g>
  </svg>
)

export const Search = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="30" height="30" fill="#14CCFF" rx="15"></rect>
      <g stroke="#000" strokeWidth="1.935" transform="translate(5.806 5.806)">
        <circle cx="7.742" cy="7.742" r="7.742" strokeLinecap="round"></circle>
        <path d="M13.175 13.659l6.422 6.422"></path>
      </g>
    </g>
  </svg>
)

export const PDF = ({ width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z"></path>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M5 3h10v4h4v1h2V5.586L16.414 1H5c-1.103 0-2 .898-2 2v5h2V3zm14 18H5v-1H3v1c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-1h-2v1zM9 10v8h2c2.206 0 4-1.794 4-4s-1.794-4-4-4H9zm4 4c0 1.103-.897 2-2 2v-4c1.103 0 2 .898 2 2zm9-2v-2h-4c-1.103 0-2 .898-2 2v6h2v-3h3v-2h-3v-1h4zM4 16h1c1.654 0 3-1.346 3-3s-1.346-3-3-3H2v8h2v-2zm0-4h1a1.001 1.001 0 010 2H4v-2z"
      ></path>
    </g>
  </svg>
)

export const PlayBtn = ({ width = 111, height = 110, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 111 110"
    {...props}
  >
    <g fill="none">
      <ellipse
        cx="55.1"
        cy="55.1"
        fill="#1897BA"
        fillOpacity="0.312"
        rx="55.1"
        ry="54.862"
      ></ellipse>
      <path
        fill="#6FE0FF"
        d="M55.1 104.263c-27.12-.131-49.013-22.2-48.926-49.321.087-27.121 22.12-49.049 49.242-49.005C82.537 5.98 104.5 27.979 104.5 55.1c-.096 27.204-22.195 49.197-49.4 49.163zm0-94.526c-25.022.131-45.213 20.499-45.126 45.52.087 25.023 20.42 45.25 45.442 45.206C80.438 100.42 100.7 80.123 100.7 55.1c-.094-25.107-20.493-45.4-45.6-45.363z"
      ></path>
      <path
        fill="#6FE0FF"
        d="M41.8 34.002v42.196c-.008.7.374 1.346.992 1.675.617.33 1.366.289 1.943-.107l30.448-21.098a1.913 1.913 0 000-3.136L44.735 32.434a1.874 1.874 0 00-2.935 1.568z"
      ></path>
    </g>
  </svg>
)

export const Arrow = ({ small, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={small ? "38.153" : "46.153"}
    height="35.25"
    viewBox="0 0 46.153 35.25"
    {...props}
  >
    <path
      fill="#1898bc"
      d="M-469.598 2442.123a3.355 3.355 0 011.884.568l18.062 12.051 17.5-12.17a3.41 3.41 0 013.78 5.677l-19.388 13.425a3.4 3.4 0 01-3.78.005l-19.949-13.305a3.416 3.416 0 011.891-6.252z"
      className="a"
      transform="translate(473 -2442)"
    ></path>
    <path
      fill="#1898bc"
      d="M-469.598 2457.123a3.355 3.355 0 011.884.568l18.062 12.051 17.5-12.17a3.41 3.41 0 013.78 5.677l-19.388 13.425a3.4 3.4 0 01-3.78.005l-19.949-13.305a3.416 3.416 0 011.891-6.252z"
      className="a"
      transform="translate(473 -2442)"
    ></path>
  </svg>
)

export const Checkmark = ({ width = 22, height = 22, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="#1898BC"
      d="M437.3 30L202.7 339.3 64 200.7 0 264.7 213.3 478 512 94z"
    ></path>
  </svg>
)

export const QuoteRight = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.74"
    height="18.42"
    data-name="Layer 1"
    viewBox="0 0 24.74 20.42"
    {...props}
  >
    <path
      d="M1687.94 795.62l-1.41-3.81a6.77 6.77 0 003.53-2.62 7.6 7.6 0 001.29-4.44h-4.74v-9.54h9.13v9.37a11.66 11.66 0 01-1.9 7 12 12 0 01-5.9 4.04zM1703.46 795.62l-1.41-3.81a6.73 6.73 0 003.53-2.62 7.6 7.6 0 001.29-4.44h-4.73v-9.54h9.13v9.37a11.66 11.66 0 01-1.91 7 12 12 0 01-5.9 4.04z"
      transform="translate(-1686.53 -775.21)"
    ></path>
  </svg>
)

export const QuoteLeft = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.74"
    height="18.42"
    data-name="Layer 1"
    viewBox="0 0 24.74 20.42"
    {...props}
  >
    <path
      d="M1319.2 659.71l1.42 3.82a6.72 6.72 0 00-3.53 2.61 7.64 7.64 0 00-1.29 4.44h4.73v9.55h-9.13v-9.38a11.7 11.7 0 011.91-7 12 12 0 015.89-4.04zM1303.68 659.71l1.41 3.82a6.73 6.73 0 00-3.52 2.61 7.64 7.64 0 00-1.29 4.44h4.72v9.55h-9.13v-9.38a11.7 11.7 0 011.91-7 12 12 0 015.9-4.04z"
      transform="translate(-1295.88 -659.71)"
    ></path>
  </svg>
)
export const Tape = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="405.4"
    height="413.7"
    data-name="Layer 1"
    viewBox="0 0 405.4 413.7"
    {...props}
  >
    <path
      fill="#1898bc"
      d="M405.3 99.3c-5.3-5.3-7.9-2.7-13.2-8-5.3-5.3-6.4-4.2-11.7-9.5-5.3-5.3 3.3-13.9-2-19.2-5.3-5.3-2.9-7.8-8.2-13.1-5.3-5.3-5.6-5-10.9-10.3s-12.8 2.2-18.1-3.2c-5.3-5.3 1.9-12.5-3.4-17.8-5.3-5.3-12.8 2.2-18.1-3.1-5.3-5.3-.7-9.9-6-15.2L0 313.8c5.3 5.3 6 4.6 11.3 9.9 5.3 5.3 6.4 4.2 11.7 9.5 5.3 5.3-2 12.6 3.3 17.9s12.3-1.6 17.6 3.7c5.3 5.3 5.4 5.2 10.7 10.5 5.3 5.3-1 11.6 4.3 16.9 5.3 5.3 5 5.6 10.3 10.9 5.3 5.3 5.5 5.1 10.8 10.4 5.3 5.3 5.5 5.1 10.8 10.4L405.4 99.3z"
      className="cls-1"
      opacity="0.8"
    ></path>
  </svg>
)

export const DropdownIcon = ({
  width = 36,
  height = 36,
  color = "#fff",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      {...props}
    >
      <path fill="none" d="M0 0H24V24H0z"></path>
      <path d="M7 10l5 5 5-5"></path>
    </svg>
  )
}

export const Tag = ({ width = 170, height = 31, color = "#fff", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      data-name="Layer 1"
      viewBox="0 0 212.8 31"
      {...props}
    >
      <path
        fill="#dc3726"
        d="M0 0h212.8l-13.5 15 13.5 16H0V0z"
        className="cls-3"
        data-name="Path 2950"
      ></path>
      <g
        className="cls-2"
        data-name="Fully Booked UNTIL 2023"
        style={{ isolation: "isolate" }}
      >
        <g className="cls-2" style={{ isolation: "isolate" }}>
          <path
            fill="#fff"
            d="M10.8 22.4V8.6h5.7v1.7h-3.1v4H16v1.8h-2.6v6.3h-2.5zM21.6 22.6c-1 0-1.8-.2-2.4-.6-.6-.4-1-.9-1.2-1.6-.2-.7-.3-1.5-.3-2.5V8.6h2.4V19.4c0 .4.2.7.4.9.2.2.5.3.9.3s.8-.1 1-.3.3-.5.4-.9V8.6h2.4v9.3c0 1-.1 1.8-.3 2.5-.2.7-.6 1.2-1.2 1.6-.6.4-1.4.6-2.4.6zM27.4 22.4V8.6h2.5v12h3.3v1.7h-5.8zM34.5 22.4V8.6H37v12h3.3v1.7h-5.8zM42.7 22.4v-5.3l-2.8-8.5h2.3l1.7 5.5 1.6-5.5h2.3L45 17.1v5.3h-2.4zM53.1 22.4V8.6h3.4c.6 0 1.2 0 1.7.2s.9.3 1.3.6.6.6.8 1.1.3 1 .3 1.7 0 1-.2 1.4-.4.7-.7.9-.7.4-1.1.5c.5 0 1 .3 1.4.6.4.3.6.7.8 1.1.2.5.3 1 .3 1.7s0 1.2-.2 1.7-.4.9-.7 1.3c-.3.3-.7.6-1.2.8-.5.2-1 .3-1.7.3h-4zm2.5-8.1h.8c.5 0 .9 0 1.2-.2.3-.1.5-.4.6-.7s.2-.7.2-1.2 0-.9-.2-1.1c-.2-.3-.4-.4-.7-.5-.3 0-.7-.1-1.3-.1h-.5v3.9zm0 6.4h1c.8 0 1.3-.2 1.5-.6s.4-.9.4-1.7 0-1-.2-1.4c-.1-.3-.3-.6-.6-.8-.3-.2-.7-.3-1.2-.3h-.9v4.6zM66.4 22.6c-1 0-1.8-.2-2.3-.5-.6-.4-1-.9-1.2-1.6-.2-.7-.4-1.5-.4-2.4v-5.2c0-.9.1-1.7.4-2.4.2-.7.7-1.2 1.2-1.5.6-.4 1.4-.5 2.3-.5s1.8.2 2.4.5c.6.4 1 .9 1.2 1.5.3.7.4 1.5.4 2.4v5.2c0 .9-.1 1.7-.4 2.4-.3.7-.7 1.2-1.2 1.6s-1.4.6-2.4.6zm0-1.9c.4 0 .7 0 .9-.3.2-.2.3-.4.4-.7 0-.3.1-.7.1-1v-6.3c0-.4 0-.7-.1-1 0-.3-.2-.5-.4-.7s-.5-.3-.9-.3-.7 0-.9.3-.3.4-.4.7c0 .3-.1.7-.1 1v7.3c0 .3.2.6.4.7.2.2.5.3.9.3zM75.9 22.6c-1 0-1.8-.2-2.3-.5-.6-.4-1-.9-1.2-1.6S72 19 72 18.1v-5.2c0-.9.1-1.7.4-2.4.2-.7.7-1.2 1.2-1.5.6-.4 1.4-.5 2.3-.5s1.8.2 2.4.5c.6.4 1 .9 1.2 1.5.3.7.4 1.5.4 2.4v5.2c0 .9-.1 1.7-.4 2.4-.3.7-.7 1.2-1.2 1.6s-1.4.6-2.4.6zm0-1.9c.4 0 .7 0 .9-.3.2-.2.3-.4.4-.7 0-.3.1-.7.1-1v-6.3c0-.4 0-.7-.1-1 0-.3-.2-.5-.4-.7-.2-.2-.5-.3-.9-.3s-.7 0-.9.3-.3.4-.4.7c0 .3-.1.7-.1 1v7.3c0 .3.2.6.4.7.2.2.5.3.9.3zM81.8 22.4V8.6h2.5v6.1L87 8.6h2.4l-2.6 6.2 2.9 7.6h-2.5l-2.3-6.3-.6 1.1v5.2h-2.5zM90.7 22.4V8.6h5.8v1.8h-3.3v4h2.6v1.8h-2.6v4.6h3.3v1.7h-5.8zM97.9 22.4V8.6h3.2c1.1 0 2 .2 2.6.5.6.3 1.1.8 1.3 1.4.3.6.4 1.4.4 2.4v5c0 1-.1 1.8-.4 2.5-.3.7-.7 1.2-1.3 1.5-.6.3-1.5.5-2.5.5h-3.3zm2.5-1.8h.8c.6 0 1-.1 1.2-.3s.4-.5.5-.9V12.7c0-.6 0-1-.1-1.3s-.2-.6-.5-.7c-.2-.2-.7-.2-1.2-.2h-.7v10.2zM115.3 22.6c-1 0-1.8-.2-2.4-.6s-1-.9-1.2-1.6c-.2-.7-.3-1.5-.3-2.5V8.6h2.4V19.4c0 .4.2.7.4.9s.5.3.9.3.8-.1 1-.3.3-.5.4-.9 0-.8 0-1.2V8.6h2.4v9.3c0 1-.1 1.8-.3 2.5-.2.7-.6 1.2-1.2 1.6-.6.4-1.4.6-2.4.6zM121.1 22.4V8.6h1.8l3.3 7.9V8.6h2.1v13.8h-1.7l-3.4-8.2v8.2h-2.1zM131.8 22.4V10.5h-2.2V8.6h6.9v1.9h-2.2v11.9h-2.5zM137.8 22.4V8.6h2.5v13.8h-2.5zM142.4 22.4V8.6h2.5v12h3.3v1.7h-5.8zM153.3 22.4v-1.7l3.4-5.3c.2-.4.5-.8.7-1.1.2-.4.4-.7.5-1.1.1-.4.2-.8.2-1.2s0-.9-.3-1.2c-.2-.3-.5-.4-.9-.4s-.6.1-.8.3c-.2.2-.3.5-.4.8 0 .3-.1.7-.1 1.1v.6h-2.3v-.6c0-.8.1-1.5.4-2.2.2-.6.6-1.1 1.2-1.5.5-.4 1.2-.5 2.1-.5s2.1.3 2.7 1c.6.6.9 1.5.9 2.7s0 1.1-.2 1.5c-.2.5-.4.9-.6 1.3-.3.4-.5.8-.9 1.3l-2.8 4.3h4.2v1.9h-6.9zM165.6 22.6c-.8 0-1.5-.2-2-.5s-.9-.8-1.2-1.4-.4-1.3-.4-2.1v-6.1c0-.8.1-1.5.4-2.1.3-.6.6-1.1 1.2-1.4s1.2-.5 2-.5 1.5.2 2 .5.9.8 1.2 1.4c.3.6.4 1.3.4 2.1v6.1c0 .8-.1 1.5-.4 2.1s-.7 1.1-1.2 1.4c-.5.3-1.2.5-2 .5zm0-2c.4 0 .6-.1.8-.3.2-.2.3-.5.3-.8v-6.9-.9c0-.3-.2-.6-.3-.8-.2-.2-.4-.3-.8-.3s-.6.1-.8.3c-.2.2-.3.5-.3.8V19.5c0 .3.2.6.3.8.2.2.4.3.8.3zM170.8 22.4v-1.7l3.4-5.3c.2-.4.5-.8.7-1.1.2-.4.4-.7.5-1.1s.2-.8.2-1.2 0-.9-.3-1.2c-.2-.3-.5-.4-.8-.4s-.6.1-.9.3c-.2.2-.3.5-.4.8 0 .3-.1.7-.1 1.1v.6h-2.3v-.6c0-.8.1-1.5.4-2.2.2-.6.6-1.1 1.2-1.5.5-.4 1.2-.5 2.1-.5s2.1.3 2.7 1c.6.6.9 1.5.9 2.7s0 1.1-.2 1.5c-.2.5-.4.9-.6 1.3s-.5.8-.8 1.3l-2.8 4.3h4.2v1.9H171zM182.8 22.6c-.9 0-1.6-.2-2.1-.5s-.9-.8-1.1-1.4c-.2-.6-.4-1.3-.4-2.1v-.5h2.3v.4c0 .4 0 .8.1 1.1 0 .3.2.5.4.7.2.2.4.2.8.2s.6 0 .8-.3c.2-.2.3-.4.4-.7v-1.2c0-.7-.1-1.3-.3-1.7-.2-.4-.6-.6-1.3-.7h-.4V14h.4c.6 0 1.1-.2 1.3-.5.2-.3.4-.8.4-1.6s0-1-.3-1.4c-.2-.3-.5-.5-1-.5s-.8.2-1 .5-.3.8-.3 1.4v.5h-2.3v-.7c0-.8.1-1.4.4-2s.7-1 1.2-1.3c.5-.3 1.2-.4 1.9-.4s1.4.1 2 .4c.5.3.9.7 1.2 1.2.3.5.4 1.2.4 2s-.2 1.5-.5 2-.8.9-1.3 1c.4.1.7.3 1 .6.3.3.5.6.6 1.1.2.4.2 1 .2 1.6s-.1 1.6-.3 2.2c-.2.6-.6 1.1-1.1 1.5-.5.4-1.2.5-2.1.5z"
            className="cls-1"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export const Spinner = ({ width = 50, height = 28, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "auto", background: "none" }}
      width={width}
      height={height}
      display="block"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
      {...props}
    >
      <rect width="6" height="12" x="47" y="24" fill="#dc3726" rx="3" ry="6">
        <animate
          attributeName="opacity"
          begin="-0.9166666666666666s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(30 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.8333333333333334s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(60 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.75s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(90 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.6666666666666666s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(120 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.5833333333333334s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(150 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.5s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(180 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.4166666666666667s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(210 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.3333333333333333s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(240 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.25s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(270 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.16666666666666666s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(300 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.08333333333333333s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="6"
        height="12"
        x="47"
        y="24"
        fill="#dc3726"
        rx="3"
        ry="6"
        transform="rotate(330 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="0s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
    </svg>
  )
}
